export default __webpack_public_path__ + "static/media/app-screenshot.8d117cf3.png";